export const calcularSemanaEpidemiologica = (fechaTexto) => {
  if (!fechaTexto) return "";
  const fecha = new Date(`${fechaTexto}T12:00:00`);
  if (Number.isNaN(fecha.getTime())) return "";
  const primerDomingo = (anio) => {
    const inicio = new Date(anio, 0, 1, 12, 0, 0);
    inicio.setDate(inicio.getDate() + ((7 - inicio.getDay()) % 7));
    return inicio;
  };
  let inicio = primerDomingo(fecha.getFullYear());
  if (fecha < inicio) inicio = primerDomingo(fecha.getFullYear() - 1);
  return Math.floor((fecha - inicio) / (7 * 86400000)) + 1;
};
